module.exports = __webpack_public_path__ + "static/media/virtual_world.9d422439.png";